/* ─── Formulaire diagnostic : état chargement au submit ────────────────
   Formulaire Shopify natif ('contact', rechargement complet de page) :
   pas d'appel fetch, pas d'état succès animé possible (la page navigue
   avant qu'on le voie). Seul rôle de ce script : désactiver le bouton et
   basculer l'icône vers le spinner au clic, pour éviter un double-envoi
   pendant le court instant avant le rechargement. */
document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.tapn-fiches-page__form');
  var button = document.querySelector('[data-tapn-fiches-submit]');
  if (!form || !button) return;

  form.addEventListener('submit', function (e) {
    if (e.defaultPrevented || button.disabled) return;
    button.disabled = true;
    var defaultIcon = button.querySelector('[data-tapn-fiches-submit-icon="default"]');
    var loadingIcon = button.querySelector('[data-tapn-fiches-submit-icon="loading"]');
    if (defaultIcon) defaultIcon.hidden = true;
    if (loadingIcon) loadingIcon.hidden = false;
  });
});

/* ─── Bascule « Paiement mensuel » / « Paiement en une fois » ──────────
   Pose la valeur choisie dans `data-billing` sur le conteneur des cartes
   (le CSS affiche ou masque les deux variantes de prix) et met à jour
   `aria-pressed` pour les lecteurs d'écran. Aucun calcul ici : les
   montants sont écrits dans le Liquid. */
document.addEventListener('DOMContentLoaded', function () {
  var plans = document.querySelector('[data-tapn-billing-plans]');
  var options = document.querySelectorAll('[data-tapn-billing]');
  if (!plans || !options.length) return;

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      plans.setAttribute('data-billing', option.dataset.tapnBilling);
      options.forEach(function (other) {
        other.setAttribute('aria-pressed', String(other === option));
      });
    });
  });
});

/* ─── Interrupteur « Mensuel / Comptant » : bascule à chaque tap ─────────
   Sur mobile les 2 boutons de paiement ne sont plus que les 2 moitiés de
   l'interrupteur (24 septembre 2026). Taper la moitié déjà active (celle où
   se trouve le rond) ne changeait rien : un interrupteur doit basculer à
   chaque tap. Écouteur en phase de capture sur le rail : si la moitié
   touchée est déjà active, le clic est redirigé vers l'autre moitié, et le
   script de bascule ci-dessus fait le reste. Sans effet sur desktop : le
   rail y est en `display:contents` et chaque bouton y garde sa pilule. */
document.addEventListener('DOMContentLoaded', function () {
  var track = document.querySelector('.tapn-fiches-page__payment-switch');
  if (!track) return;
  var mobile = window.matchMedia('(max-width: 47.999rem)');

  track.addEventListener('click', function (e) {
    if (!mobile.matches) return;
    var half = e.target.closest('.tapn-fiches-page__payment-half');
    if (!half || half.getAttribute('aria-pressed') !== 'true') return;
    var other = track.querySelector('.tapn-fiches-page__payment-half[aria-pressed="false"]');
    if (!other) return;
    e.stopPropagation();
    other.click();
  }, true);
});

/* ─── Sélecteur de formule, mobile uniquement (23 septembre 2026) ───────
   Pose `data-tapn-duration` sur `.plans` (le CSS n'affiche qu'une carte à
   la fois, sous 48rem seulement). Même mécanique que la bascule de
   paiement ci-dessus : rien n'est calculé ici, le CSS fait tout.
   L'attribut n'existe pas dans le Liquid (repli sans JS : les 3 cartes
   restent visibles) — ce script pose la valeur par défaut (6 mois) au
   chargement, seul moment où l'état initial doit être écrit. */
document.addEventListener('DOMContentLoaded', function () {
  var plans = document.querySelector('[data-tapn-billing-plans]');
  var options = document.querySelectorAll('[data-tapn-duration]');
  if (!plans || !options.length) return;

  plans.setAttribute('data-tapn-duration', '6m');

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      plans.setAttribute('data-tapn-duration', option.dataset.tapnDuration);
      options.forEach(function (other) {
        other.setAttribute('aria-pressed', String(other === option));
      });
    });
  });
});

/* ─── Chiffres 93 % / 83 % en compteur (23 septembre 2026) ───────────────
   Même recette que le compteur du panneau « Avant de venir, le client vous
   compare » plus bas dans ce fichier (durée, courbe, délai entre les 2
   chiffres) : dupliquée plutôt que factorisée, les 2 blocs n'ont pas le
   même conteneur ni le même déclencheur. Sans JS ou avec « réduire les
   animations », les chiffres restent à leur valeur finale (93/83, déjà
   dans le HTML) : on ne les met à 0 que dans la branche animée. */
document.addEventListener('DOMContentLoaded', function () {
  var statsBlock = document.querySelector('.tapn-fiches-page__ego-stats');
  if (!statsBlock) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var counters = statsBlock.querySelectorAll('[data-tapn-count]');
  if (!counters.length) return;
  counters.forEach(function (counter) { counter.textContent = '0'; });

  var countUp = function (el, delay) {
    var target = parseInt(el.getAttribute('data-tapn-count'), 10);
    var start = performance.now() + delay;
    var step = function (now) {
      var p = Math.min(Math.max((now - start) / 2500, 0), 1);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  var observer = new IntersectionObserver(function (entries, obs) {
    if (!entries[0].isIntersecting) return;
    counters.forEach(function (counter, i) { countUp(counter, i * 150); });
    obs.disconnect();
  }, { rootMargin: '0px 0px -10% 0px' });
  observer.observe(statsBlock);
});

/* ─── FAQ repliée, mobile uniquement (23 septembre 2026) ─────────────────
   5 questions visibles (1re colonne), bouton « Voir plus de questions »
   (libellé changé le 24 septembre 2026, était « Voir les 5 autres
   questions ») qui déroule la 2e colonne puis disparaît. Construit
   entièrement en JS : sans JavaScript, aucune classe n'est ajoutée et les
   10 questions restent visibles (repli déjà en place, cf. le CSS scopé à
   `.is-faq-collapsed`). L'effet visuel (masquer la 2e colonne) est lui-même
   scopé au mobile dans le CSS, donc ce script peut tourner sans condition
   de largeur ici. */
document.addEventListener('DOMContentLoaded', function () {
  var block = document.querySelector('.tapn-fiches-page__faq-block');
  var columns = block && block.querySelectorAll('.tapn-faq-column');
  if (!block || !columns || columns.length < 2) return;

  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'tapn-fiches-page__faq-more';
  button.textContent = 'Voir plus de questions';
  columns[1].insertAdjacentElement('afterend', button);
  block.classList.add('is-faq-collapsed');

  button.addEventListener('click', function () {
    block.classList.remove('is-faq-collapsed');
    button.remove();
  });
});

/* ─── Boutons d'offre : pré-remplissent le formulaire (20 septembre 2026) ──
   Au clic sur « Contactez-nous » d'une carte, le lien ancre descend au
   formulaire (comportement natif) et ce script y écrit le pré-message de la
   formule, lit le mode de paiement affiché (`data-billing`) pour choisir la
   variante « mensuel » ou « en une fois », affiche « Formule choisie » et
   renseigne les champs cachés Formule et Sujet (visibles dans l'e-mail reçu).
   Les textes sont écrits dans le Liquid (data-plan-*), rien n'est calculé ici.
   Un message que le client a écrit lui-même n'est jamais écrasé : seul un
   champ vide, ou contenant encore le dernier pré-message, est remplacé.
   Sans JavaScript, le bouton descend au formulaire sans pré-message. */
document.addEventListener('DOMContentLoaded', function () {
  var plans = document.querySelector('[data-tapn-billing-plans]');
  var message = document.getElementById('DiagnosticMessage');
  var recap = document.querySelector('[data-tapn-form-plan]');
  var recapLabel = document.querySelector('[data-tapn-form-plan-label]');
  var planInput = document.querySelector('[data-tapn-form-plan-input]');
  var subject = document.querySelector('[data-tapn-form-subject]');
  var ctas = document.querySelectorAll('[data-tapn-plan-cta]');
  if (!plans || !message || !ctas.length) return;

  var lastPrefill = '';
  ctas.forEach(function (cta) {
    cta.addEventListener('click', function () {
      var once = plans.getAttribute('data-billing') === 'once';
      var text = (once && cta.dataset.planMessageOnce) || cta.dataset.planMessage;
      var label = (once && cta.dataset.planLabelOnce) || cta.dataset.planLabel;

      if (message.value.trim() === '' || message.value === lastPrefill) {
        message.value = text;
        lastPrefill = text;
      }
      if (recap && recapLabel) {
        recapLabel.textContent = label;
        recap.hidden = false;
      }
      if (planInput) {
        planInput.value = label;
        planInput.disabled = false;
      }
      if (subject) subject.value = 'Tapn Fiches Google : ' + label;
    });
  });
});

/* ─── Section « Avant de venir, le client vous compare aux autres » ─────
   Recrée en JS natif le template d'Amine (à l'origine Tailwind + GSAP en CDN) :
   1. les mots du titre et du sous-titre remontent un à un ;
   2. les 3 blocs de chiffres apparaissent et les chiffres montent de 0 à leur
      valeur (le HTML contient déjà la valeur finale, c'est le repli sans JS) ;
   3. une vague de 70 lignes est dessinée dans un canvas derrière le contenu.
   « Réduire les animations » (ou un navigateur sans IntersectionObserver) : rien
   n'est masqué ni animé, les chiffres restent à leur valeur finale et la vague
   est dessinée une seule fois. La boucle de la vague s'arrête dès que le panneau
   sort de l'écran, pour ne pas consommer de batterie pour rien. */
document.addEventListener('DOMContentLoaded', function () {
  var panel = document.querySelector('[data-tapn-compare]');
  if (!panel) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animate = !reduce && 'IntersectionObserver' in window;

  // ─── Mots et chiffres ─────────────────────────────────────────────
  if (animate) {
    var wordBlocks = panel.querySelectorAll('[data-tapn-words]');
    var stats = panel.querySelector('[data-tapn-stats]');
    var counters = panel.querySelectorAll('[data-tapn-count]');

    // Chaque mot est enveloppé (l'enveloppe masque, le mot glisse dedans). De vrais
    // espaces sont gardés entre les mots pour que le lecteur d'écran lise la phrase.
    wordBlocks.forEach(function (block) {
      var words = block.textContent.split(/\s+/).filter(Boolean);
      block.textContent = '';
      words.forEach(function (word, i) {
        if (i) block.appendChild(document.createTextNode(' '));
        var wrap = document.createElement('span');
        wrap.className = 'tapn-fiches-page__word';
        var inner = document.createElement('span');
        inner.className = 'tapn-fiches-page__word-inner';
        inner.style.transitionDelay = (i * 20) + 'ms';
        inner.textContent = word;
        wrap.appendChild(inner);
        block.appendChild(wrap);
      });
    });
    counters.forEach(function (counter) { counter.textContent = '0'; });
    panel.classList.add('is-armed');

    // Compte 0 -> valeur en 2,5 s, ralentissement en fin de course (power3.out).
    var countUp = function (el, delay) {
      var target = parseInt(el.getAttribute('data-tapn-count'), 10);
      var start = performance.now() + delay;
      var step = function (now) {
        var p = Math.min(Math.max((now - start) / 2500, 0), 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    // Déclenchement à l'entrée dans l'écran, une seule fois (10 % de marge pour le texte, 5 % pour les chiffres).
    var wordsObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    wordBlocks.forEach(function (block) { wordsObserver.observe(block); });

    if (stats) {
      var statsObserver = new IntersectionObserver(function (entries, observer) {
        if (!entries[0].isIntersecting) return;
        stats.classList.add('is-in');
        counters.forEach(function (counter, i) { countUp(counter, i * 150); });
        observer.disconnect();
      }, { rootMargin: '0px 0px -5% 0px' });
      statsObserver.observe(stats);
    }
  }

  // ─── Vague néon ───────────────────────────────────────────────────
  // Même formule que le template : 70 lignes, chacune un dégradé rose > violet > bleu,
  // qui s'écartent vers la droite. 40 lignes sous 768px (moins de calcul sur téléphone),
  // résolution plafonnée à x2, temps mesuré en vraies millisecondes (sur un écran 120 Hz
  // le template allait 2 fois trop vite). Pas de réaction au survol : rien de cliquable.
  var canvas = panel.querySelector('[data-tapn-wave]');
  var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
  if (!ctx) return;

  var width = 0;
  var height = 0;
  var time = 0;
  var frameId = 0;
  var lastTick = 0;
  var GLOW = 0.5;

  var draw = function () {
    ctx.clearRect(0, 0, width, height);
    ctx.globalCompositeOperation = 'screen';
    var lines = width < 768 ? 40 : 70;
    for (var i = 0; i < lines; i++) {
      var normalizedI = (i / lines) * 2 - 1;
      var grad = ctx.createLinearGradient(0, 0, width, 0);
      grad.addColorStop(0, 'rgba(255, 110, 199, 0)');
      grad.addColorStop(0.2, 'rgba(255, 110, 199, ' + (GLOW * 0.25) + ')');
      grad.addColorStop(0.5, 'rgba(190, 80, 255, ' + (GLOW * 0.35) + ')');
      grad.addColorStop(0.8, 'rgba(100, 150, 255, ' + (GLOW * 0.25) + ')');
      grad.addColorStop(1, 'rgba(100, 150, 255, 0)');
      ctx.strokeStyle = grad;
      ctx.lineWidth = 1.2;
      ctx.beginPath();
      for (var x = 0; x <= width; x += 20) {
        var nx = x / width;
        var spread = Math.pow(nx, 2.5) * (height * 0.4);
        var wave1 = Math.sin(nx * Math.PI * 1.8 + time * 0.0006 + normalizedI * 0.6);
        var wave2 = Math.cos(nx * Math.PI * 2.3 - time * 0.0006 * 1.1);
        var y = height * 0.55 + nx * (height * 0.05) + normalizedI * spread + wave1 * spread * 0.35 + wave2 * spread * 0.15;
        if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
  };

  var tick = function (now) {
    time += Math.min(now - lastTick, 50);
    lastTick = now;
    draw();
    frameId = requestAnimationFrame(tick);
  };
  var play = function () {
    if (frameId || reduce) return;
    lastTick = performance.now();
    frameId = requestAnimationFrame(tick);
  };
  var pause = function () {
    cancelAnimationFrame(frameId);
    frameId = 0;
  };

  var resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    width = panel.offsetWidth;
    height = panel.offsetHeight;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    draw();
  };

  resize();
  if ('ResizeObserver' in window) new ResizeObserver(resize).observe(panel);
  else window.addEventListener('resize', resize);

  if (!reduce && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) play(); else pause();
    }).observe(panel);
  }
});
